import { j as s } from "../../../../jsx-runtime.BREq8dyb.js";
import { memo as n, useMemo as u } from "react";
import "../../contexts/DatasetContext/DatasetContext.js";
import { FeatureProvider as p } from "../../contexts/FeatureContext/FeatureContext.js";
import "../../contexts/FileContext/FileContext.js";
import "../../contexts/IntrospectionContext/IntrospectionContext.js";
import { useNavigator as c } from "../../contexts/NavigatorContext/NavigatorContext.js";
import "../../contexts/OptionsContext/OptionsContext.js";
import { useSchema as l } from "../../contexts/SchemaContext/SchemaContext.js";
import "../../contexts/TypificationContext/TypificationContext.js";
import "../../contexts/WorkerContext/WorkerContext.js";
const d = n(({
  children: m,
  isUnboundUpload: r
}) => {
  const {
    currentStep: e
  } = c(), {
    deferred: o,
    schema: a
  } = l(), t = (a?.columns?.length || 0) > 0, i = u(() => ({
    showColumnSelection: e >= 2 && !o,
    showNavigator: t || o,
    showRowSelection: e >= 2,
    uploadMode: r ? "unbound" : "provisioning",
    useDeferredSchemaTableHeader: o && e >= 1
  }), [t, o, e, r]);
  return /* @__PURE__ */ s.jsx(p, { value: i, children: m });
});
d.displayName = "FeatureContainer";
export {
  d as default
};
//# sourceMappingURL=FeatureContainer.js.map
